import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getRefundReport({ commit }, payload) {
    const { filters = {} } = payload || {};

    const { type_filter } = filters;

    const searchByNumersOf = {
      FilterByTrackingCode: 'TRACKING_CODE',
      FilterByOrderNumber: 'ORDER_NUMBER',
      FilterByPiNumber: 'PI_NUMBER',
      FilterByDate: 'FILTERS',
    };

    const type = searchByNumersOf[type_filter];

    commit('toggleLoading', true);

    return GraphQlClient.query(
      `
  query (
     $date_range: DateRangeInput,
     $date_range_response: DateRangeInput,
     $status_pi: String,
     $sub_status_pi: String,
     $condition: String,
     $pi_numbers: [String],
     $order_numbers: [String],
     $tracking_codes: [String],
     $type: String) {
  refund_report(
    date_range: $date_range,
    date_range_response: $date_range_response,
    status_pi: $status_pi,
    sub_status_pi: $sub_status_pi,
    condition: $condition,
    pi_numbers: $pi_numbers,
    order_numbers: $order_numbers,
    tracking_codes: $tracking_codes,
    type: $type) {
   items {
      number
      opening_reason
      solicitation_date
      status
      substatus
      response_time
      last_tracking_status
      end_customer_name
      tracking_code
      opening_date_pi
      order_number
      delivery_estimate_lp
      date_of_request_post_office
      reason_for_pidescription
      answer_deadline
    }
  }
}`,
      { ...filters, type },
    )
      .then((res) => {
        const { data = {} } = res || {};
        const { refund_report = [] } = data || {};
        const { items } = refund_report;

        commit('toggleLoading', false);
        commit('setRefunds', { items });

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  getRefundExport({ commit }, payload) {
    const { filters = {} } = payload || {};

    const { type_filter } = filters;

    const searchByNumersOf = {
      FilterByTrackingCode: 'TRACKING_CODE',
      FilterByOrderNumber: 'ORDER_NUMBER',
      FilterByPiNumber: 'PI_NUMBER',
      FilterByDate: 'FILTERS',
    };

    const type = searchByNumersOf[type_filter];

    return GraphQlClient.query(
      `
  query (
     $date_range: DateRangeInput,
     $date_range_response: DateRangeInput,
     $status_pi: String,
     $sub_status_pi: String,
     $condition: String,
     $pi_numbers: [String],
     $order_numbers: [String],
     $tracking_codes: [String],
     $type: String) {
  refund_export(
    date_range: $date_range,
    date_range_response: $date_range_response,
    status_pi: $status_pi,
    sub_status_pi: $sub_status_pi,
    condition: $condition,
    pi_numbers: $pi_numbers,
    order_numbers: $order_numbers,
    tracking_codes: $tracking_codes,
    type: $type) {

    message
  }
}`,
      { ...filters, type },
    )
      .then((res) => {
        const { data = {} } = res || {};
        const { refund_export = [] } = data || {};
        const { message } = refund_export;

        commit('toggleLoading', false);

        ScToast.success(message);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  getStatusPi({ commit }) {
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `
			query  {
				status_pi {
					status_pi_data{
					code
					description
					}
				}
			}
			`,
    )
      .then((response) => {
        commit('toggleLoading', false);

        const { data } = response;
        const { status_pi } = data;
        const { status_pi_data } = status_pi;
        commit('setStatusPi', status_pi_data);
        return Promise.resolve(response);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  getSubStatusPi({ commit }) {
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `
			query  {
				sub_status_pi {
					sub_status_pi_data {
					code
					description
					}
				}
			}
			`,
    )
      .then((response) => {
        commit('toggleLoading', false);

        const { data } = response;
        const { sub_status_pi } = data;
        const { sub_status_pi_data } = sub_status_pi;
        commit('setSubStatusPi', sub_status_pi_data);

        return Promise.resolve(response);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-refund/features/export-xls/store/actions.js